import { Injectable } from '@angular/core';
import { BaseService, CalendarEventAttendanceStatus, Icon, IconItem, StatusKind } from '@sb/library/base';
import { AttendanceStatus, CalendarAttendanceDisplayItem } from '@sb/library/data-models';
import { LocalizationService } from '@sb/library/localization';

@Injectable({
    providedIn: 'root'
})
export class AttendanceManager extends BaseService {

    constructor(protected _LocalizationService: LocalizationService) {
        super();
    }

    GetStatusAndText(status: AttendanceStatus): {Status: StatusKind, Text: string, Icon: IconItem, DetailedStatus: StatusKind} {
        if (status === AttendanceStatus.Present) {
            return {
                Status: StatusKind.Success,
                Text: $localize `:@@CommonAttendanceStatusPresentCurrency:Present (${this.currencySymbol})`,
                Icon: Icon.Attendance.Present,
                DetailedStatus: StatusKind.Success,
            }
        } else if (status === AttendanceStatus.PresentMakeup) {
            return {
                Status: StatusKind.Success,
                Text: $localize `:@@CommonAttendancePresentMakeUp:Present, Use Make-Up Credit`,
                Icon: Icon.Attendance.PresentUseMakeup,
                DetailedStatus: StatusKind.Success,
            }
        } else if (status === AttendanceStatus.PresentLate) { //check with UX
            return {
                Status: StatusKind.Success,
                Text: $localize `:@@CommonAttendancePresentLateCurrency:Present, Late (${this.currencySymbol})`,
                Icon: Icon.Attendance.PresentLate,
                DetailedStatus: StatusKind.Warning,
            }
        } else if (status === AttendanceStatus.PresentLateMakeUp) { //check with UX
            return {
                Status: StatusKind.Success,
                Text: $localize `:@@CommonAttendancePresentLateUseMakeUp:Present, Late, Use Make-Up Credit`,
                Icon: Icon.Attendance.PresentLateUseMakeup,
                DetailedStatus: StatusKind.Warning,
            }
        } else if (status === AttendanceStatus.AbsentNoMakeup) {
            return {
                Status: StatusKind.Danger,
                Text: $localize `:@@CommonAttendanceAbsentNoMakeUp:Absent, No Make-Up Credit (${this.currencySymbol})`,
                Icon: Icon.Attendance.Absent,
                DetailedStatus: StatusKind.Danger,
            }
        } else if (status === AttendanceStatus.AbsentMakeup) {
            return {
                Status: StatusKind.Danger,
                Text: $localize `:@@CommonAttendanceAbsentIssueMakeUp:Absent, Issue Make-Up Credit (${this.currencySymbol})`,
                Icon: Icon.Attendance.AbsentGiveMakeup,
                DetailedStatus: StatusKind.Danger,
            }
        } else if (status === AttendanceStatus.AbsentNotice) {
            return {
                Status: StatusKind.Danger,
                Text: $localize `:@@CommonAttendanceAbsentNoticeGiven:Absent, Notice Given`,
                Icon: Icon.Attendance.AbsentNotice,
                DetailedStatus: StatusKind.Danger,
            }
        } else if (status === AttendanceStatus.AbsentUseMakeup) {
            return {
                Status: StatusKind.Danger,
                Text: $localize `:@@CommonAttendanceAbsentUseMakeUp:Absent, Use Make-Up Credit`,
                Icon: Icon.Attendance.AbsentUseMakeup,
                DetailedStatus: StatusKind.Danger,
            }
        } else if (status === AttendanceStatus.TeacherAbsentNoMakeup) {
            return {
                Status: StatusKind.Danger,
                Text: $localize `:@@CommonAttendanceTeacherAbsent:#Teacher# Cancelled`,
                Icon: Icon.Attendance.TeacherCanceled,
                DetailedStatus: StatusKind.Neutral,
            }
        } else if (status === AttendanceStatus.TeacherAbsentMakeup) {
            return {
                Status: StatusKind.Danger,
                Text: $localize `:@@CommonAttendanceTeacherAbsentMakeUpCurrency:#Teacher# Cancelled, Issue Make-Up Credit (${this.currencySymbol})`,
                Icon: Icon.Attendance.TeacherCanceledMakeup,
                DetailedStatus: StatusKind.Neutral,
            }
        } else { //status.Unrecorded
            return {
                Status: StatusKind.Neutral,
                Text: $localize `:@@CommonAttendanceStatusUnrecorded:Unrecorded`,
                Icon: Icon.Attendance.Unrecorded,
                DetailedStatus: StatusKind.Neutral,
            }
        }
    }

    get currencySymbol(): string | null {
        return this._LocalizationService.CurrencyFormatInfo.CurrencySymbol;
    }

    FindCalendarEventAttendanceStatus(attendances: Array<CalendarAttendanceDisplayItem>, lookingForAbsences?: boolean): CalendarEventAttendanceStatus {
        let numOfRecordedAttendances: number = 0;
        let numOfPresentAttendees: number = 0;
        let editableAttendances = attendances.filter(attendance => attendance.Editable);
        editableAttendances.forEach(attendance => {
            if (attendance.AttendanceStatus !== AttendanceStatus.Unrecorded) {
                numOfRecordedAttendances++;
                if (attendance.AttendanceStatus === AttendanceStatus.Present ||
                    attendance.AttendanceStatus === AttendanceStatus.PresentLate ||
                    attendance.AttendanceStatus === AttendanceStatus.PresentLateMakeUp ||
                    attendance. AttendanceStatus === AttendanceStatus.PresentMakeup) {
                        numOfPresentAttendees++;
                }
            }
        });

        if (numOfRecordedAttendances === editableAttendances.length) {
            if (numOfPresentAttendees === editableAttendances.length) {
                return CalendarEventAttendanceStatus.AllPresent;
            } else if (numOfPresentAttendees === 0) {
                return CalendarEventAttendanceStatus.AllAbsent;
            } else {
                if (lookingForAbsences) {
                    return CalendarEventAttendanceStatus.AtLeastOneAbsent;
                } else {
                    return CalendarEventAttendanceStatus.AtLeastOnePresent;
                }
            }
        } else if (numOfRecordedAttendances === 0) {
            return CalendarEventAttendanceStatus.AllUnrecorded;
        } else {
            if (numOfPresentAttendees > 0 && numOfPresentAttendees === numOfRecordedAttendances) {
                return CalendarEventAttendanceStatus.AtLeastOnePresent;
            } else if (numOfPresentAttendees === 0) {
                return CalendarEventAttendanceStatus.AtLeastOneAbsent;
            } else {
                if (lookingForAbsences) {
                    return CalendarEventAttendanceStatus.AtLeastOneAbsent;
                } else {
                    return CalendarEventAttendanceStatus.AtLeastOnePresent;
                }
            }
        }
    }
}
